<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/home/99">Home99</router-link> |
      <router-link to="/activity">Activity</router-link> |
      <router-link to="/detail/1">Detail</router-link> | 
      <router-link to="/profile/gloria">Profile</router-link> | 
      <router-link to="/publish/2">Plulish</router-link> |
      <span @click="goRoute">Result</span>
    </div> -->
    <!-- <keep-alive include="communityList"> -->
      <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
  export default{
    name: 'App',
    mounted(){
      setDocumentsRem();
      window.onresize = setDocumentsRem;

      function setDocumentsRem(){
        const html = document.documentElement;
        const ww = html.clientWidth;
        let rem = ww / 28;
        rem =  ww > 500 ? 14 : (rem < 12 ? 12 : rem);
        document.documentElement.style.fontSize = rem + 'px';
      }
    },
    methods: {
      goRoute(){
        this.$router.push({
          name: 'Result',
          params: {
            id: 2
          },
          query: {
            result: 0
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  @import url('~assets/css/base.scss');
#app {
  width: 100vw;
  overflow-x: hidden;
  font-family: 'CGFONT',Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f8fa;  
}
#app, button{
  font-size: 14px;
  color: #151b25;
}
#nav {
  padding: 10px 30px;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: 0;
  /* width: 100vw; */
  box-sizing: border-box;
  z-index: 10;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.avatar{
    margin-right: .7em;
    .img{
      width: 10vw;
      height: 10vw;
      border-radius: 100%;
      border-color: #ecf2f5;
    }
  }
</style>
